import { Box, Container, Typography } from "@mui/material";
import { styled } from "@mui/system";
import CarrouselClientes from "@/components/CarrouselClientes/CarrouselClientes";
import handshake from "@/assets/shakehand.jpg";


const Banner = styled(Box)({
  backgroundImage: `url(${handshake})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  height: '200px',
});

const AboutUs = () => {
  return (<>
    <Banner />
    <Container maxWidth='xl'>
      <Typography variant="h4" component="h2" gutterBottom p={3} sx={{ fontWeight: 'bold', textAlign: 'center' }} >
        ¿Quienes somos?
      </Typography>
      <Typography variant="body1" gutterBottom sx={{ marginTop: 2, mx: { md: '10rem', sx: '0px' }, fontSize: '20px' }}>
        Somos una empresa familiar conformada por Jorge Roberto Ponce (Gestor del Registro de la Propiedad Inmueble) y Norma Silvia Marino (Martillera Pública y Gestora) desde hace más de 20 años con experiencia en comercialización de bienes raíces.
        Así surgimos en el año 2001 con el objetivo claro de brindar un servicio sumamente personalizado. Para que cada cliente se sienta único. Tratando de brindar asesoramiento en todo lo que respecta a gestión de trámites. Trabajamos desde la perspectiva del agente inmobiliario porque estuvimos allí y conocemos cuáles son tus necesidades y urgencias.
      </Typography>
      <br />
      <Typography variant="body1" gutterBottom sx={{ marginTop: 2, mx: { md: '10rem', sx: '0px' }, fontSize: '20px' }}>
        Sabemos lo que está en juego detrás de cada pedido de informe, son horas de trabajo, esfuerzo y capital de un equipo de venta que debe desenvolverse en una plaza cada día más complicada y demandante.
        Es por eso que nos sentimos comprometidos y nos esforzamos para estar a la altura de las expectativas que tienen los clientes cuando deciden contar con nuestro asesoramiento.
        Acompañando lo iniciado en el 2001 por nosotros, se suma en la actualidad un equipo de trabajo cuidadosamente capacitado para satisfacer todo lo requerido en cada llamado, en cada consulta, siempre motivados por un mismo espíritu, tu satisfacción y la mejor atención personalizada; algo que no abunda en las empresas de hoy.
        De cara al futuro queremos brindarte la practicidad de esta página para facilitar tus pedidos y consultas, manejando con rapidez y eficacia toda la información que, como siempre procesaremos, en el menor tiempo posible.
        Porque esa es la tarea del gestor, allanar las dificultades para que el trabajo al cual está abocado cada cliente resulte más sencillo, menos tedioso y eficaz.
        Contamos con tus consultas y pedidos. Te estamos esperando con la cordialidad de siempre.
      </Typography>

    </Container>
    <Box sx={{ padding: 3 }}>
      <Typography component='h5' variant='h5' sx={{ fontWeight: 'bold', fontSize: '2.5rem', textAlign: 'center', marginBottom: 0 }}>
        Algunos de nuestros clientes
      </Typography>

      <Container maxWidth='xl'>
        <CarrouselClientes modificable={false} />
      </Container>

    </Box >
  </>

  );
}

export default AboutUs;
